import { forwardRef, type Ref, type SVGProps } from "react";
const IconGridOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M12 4v8H4V4zm1-2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m15 2v8h-8V4zm1-2H19a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M12 20v8H4v-8zm1-2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V19a1 1 0 0 0-1-1m15 2v8h-8v-8zm1-2H19a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V19a1 1 0 0 0-1-1" />
  </svg>
);
const ForwardRef = forwardRef(IconGridOutlineSVG);
ForwardRef.displayName = "IconGridOutline";
export { ForwardRef as IconGridOutline };
